import { render, staticRenderFns } from "./UserEvaluatedSave.vue?vue&type=template&id=134e45b5&"
import script from "./UserEvaluatedSave.vue?vue&type=script&lang=js&"
export * from "./UserEvaluatedSave.vue?vue&type=script&lang=js&"
import style0 from "./UserEvaluatedSave.vue?vue&type=style&index=0&id=134e45b5&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports